<template>
  <div class="wgk-radio-group">
    <span class="wgk-group-title">{{label}}</span>
    <v-dialog
      v-if="imageUrl"
      v-model="showImageDialog"
      scrollable
      max-width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="secondary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            dark
            dense
            middle
          > mdi-information-outline</v-icon>
        </v-btn>

      </template>
      <v-card>

        <v-toolbar
          flat
          dark
          color="secondary"
        >
          <v-toolbar-title>{{ label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              @click="showImageDialog = false"
              icon dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-img
            :src=imageUrl
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-radio-group
      :name="name"
      :value="value"
      @change="changed"
    >
      <v-radio
        v-for="(val, key) in options"
        :key="key"
        :label="val"
        :value="key"
        class="wgk-radio"
        on-icon="mdi-checkbox-marked-circle-outline"
        color="white"
      ></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: 'RadioButton',
  props: ['label', 'name', 'options', 'value', 'imageUrl'],
  data () {
    return {
      showImageDialog: false
    }
  },
  methods: {
    changed(value) {
      this.$emit('input',value);
    },
  }
}
</script>
<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';


.v-input--radio-group__input {
  width: auto !important;
  display: block !important;
}
.wgk-radio {
  border-radius: 20px;
  display: table !important;
  background:#EBEBEB;
  padding:10px 20px;
}

.v-input--radio-group--column .wgk-radio:not(:last-child):not(:only-child) {
  margin-bottom: 16px;
}

.v-input--radio-group {
  padding-top: 0;
}

.wgk-radio.v-item--active {
  background: $c-dehn-red;
  label {
    color: $c-dehn-white;
  }
}

.wgk-radio-group {
  .v-input--selection-controls {
    padding-top: 0;
  }
}

.v-input--selection-controls .v-radio > .v-label {
  display: table-cell !important;
  vertical-align: middle;
}

</style>
